<template>
  <div class="has-padding-150">
    <div class="has-text-centered">
      <p class="is-size-5 has-margin-bottom-25">
        <strong>{{ title }}</strong>
      </p>

      <template v-if="message.length">
        <p class="has-opacity-75">{{ message }}</p>
      </template>

      <template v-if="cta.label">
        <a
          :class="cta.class"
          role="button"
          class="button is-rounded is-outlined has-margin-top-100"
          @click="$emit('click')"
        >
          <span>{{ cta.label }}</span>
        </a>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoResults",
  props: {
    icon: {
      default: "",
      type: String,
      required: false,
    },
    title: {
      default: "",
      type: String,
      required: true,
    },
    message: {
      default: "",
      type: String,
      required: false,
    },
    cta: {
      type: Object,
      default: () => {
        return {
          label: "",
          class: "",
        };
      },
    },
  },
};
</script>
